import React from 'react';
import type ServicedeskReportsCustomType from '@atlassian/jira-spa-apps-servicedesk-reports-custom/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

export const LazyServicedeskReportsCustom = lazyForPaint<typeof ServicedeskReportsCustomType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-reports-custom", jiraSpaEntry: "async-servicedesk-reports-custom" */ '@atlassian/jira-spa-apps-servicedesk-reports-custom'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({ match }: RouteContext) => {
	const reportType = match.params.reportType || '';
	return (
		<LazyPage
			Page={LazyServicedeskReportsCustom}
			pageId={`spa-apps/servicedesk/reports/${reportType}`}
			shouldShowSpinner
		/>
	);
};
